import { generateUrlForRoute } from '@frontend/utils/hooks/useNavigateTo';
import type { FormattedOutpatientClinicTask } from '../types/formattedOutpatientClinicTask';

export function getOutpatientClinicTaskUrl(patientTask: FormattedOutpatientClinicTask): string {
    const episodeCategoryName = patientTask.episodeCategory.name;
    const itemId = patientTask.id;
    const patientId = patientTask.patient.id;

    if (patientTask.isFlexibleCarePath) {
        return generateUrlForRoute(
            'patientCarePath',
            {
                activeTab: 'support',
                episodeCategory: episodeCategoryName,
                patientId,
            },
            { itemId }
        );
    }

    return `/contactsAndTasks?patientId=${patientId}&episodeCategory=${episodeCategoryName}&itemId=${itemId}`;
}
